import { useEffect, useState } from 'react';
import ContactProfileSection from './panelSections/ContactProfileSection';
import PrizesPanel from './panelSections/PrizesPanel';
import ProfileResumeSection from './panelSections/ProfileResumeSection';
import ExchangesPanel from './panelSections/ExchangesPanel';
import ContactRanking from './components/ContactRanking';
import User from './hooks/User';

const Profile = ({
  user,
  theme,
  setUser,
  permissions,
  logout,
  losesAccess,
  setProfile,
  message,
  onLogout
}) => {
  const vm = User({ user, setUser, logout, message });
  const [isDesktop, setIsDesktop] = useState(() => (
    typeof window !== 'undefined'
      ? window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)').matches
      : true
  ));

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)');
    const handleChange = (event) => setIsDesktop(event.matches);

    setIsDesktop(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const rankingCard = <ContactRanking user={user} logout={logout} message={message} variant="inline" />;

  const profileCard = (className = '') => (
    <ContactProfileSection
      userLogin={vm.currentUser}
      theme={theme}
      onUser={vm.syncUser}
      permissions={permissions}
      logout={logout}
      losesAccess={losesAccess}
      message={message}
      onLogout={onLogout}
      ranking={rankingCard}
      className={className}
    />
  );

  const activitiesCard = (className = '') => (
    <ProfileResumeSection
      score={vm.score}
      currentUser={vm.currentUser}
      logout={logout}
      losesAccess={losesAccess}
      message={message}
      className={className}
    />
  );

  const exchangesCard = (className = '') => (
    <ExchangesPanel exchanges={vm.exchanges} className={className} />
  );

  const prizesCard = (className = '') => (
    <PrizesPanel
      setProfile={setProfile}
      prizes={vm.prizes}
      losesAccess={losesAccess}
      className={className}
    />
  );

  if (!isDesktop) {
    return (
      <div className="profile-dashboard bg-gray-100 grid grid-cols-1 items-start gap-4 md:grid-cols-2">
        <div className="flex flex-col gap-4">
          {profileCard()}
          {activitiesCard()}
        </div>

        <div className="flex flex-col gap-4">
          {prizesCard()}
          {exchangesCard()}
        </div>
      </div>
    );
  }

  return (
    <div className="profile-dashboard bg-gray-100 grid grid-cols-1 items-start gap-4 md:grid-cols-2 xl:mx-auto xl:w-full xl:max-w-[1180px] xl:grid-cols-[minmax(18rem,22rem)_minmax(0,1fr)] xl:gap-6">
      <div className="profile-dashboard-column contents xl:col-start-1 xl:row-start-1 xl:flex xl:min-h-0 xl:flex-col xl:gap-5">
        <div className="order-1 xl:order-none xl:min-h-0">
          {profileCard('xl:h-auto')}
        </div>
        <div className="order-5 xl:order-none xl:min-h-0">
          {prizesCard('xl:h-auto')}
        </div>
      </div>

      <div className="profile-dashboard-column profile-history-column contents xl:col-start-2 xl:row-start-1 xl:flex xl:min-h-0 xl:flex-col xl:gap-6">
        <div className="order-3 xl:order-none xl:min-h-0">
          {activitiesCard('xl:h-auto xl:self-start xl:w-full')}
        </div>
        <div className="order-4 xl:order-none xl:min-h-0">
          {exchangesCard('xl:h-auto')}
        </div>
      </div>
    </div>
  );
};

export default Profile;
